import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import SEO from "@/components/SEO";
import { useI18n } from "@/i18n";

const NotFound = () => {
  const location = useLocation();
  const { t } = useI18n();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <SEO
        title={`${t("notfound.seo.title")} | ${t("brand.name")}`}
        description={t("notfound.seo.description")}
        canonical="https://trimr.cc"
      />
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="text-center space-y-6 px-4">
          <h1 className="text-7xl font-extrabold text-muted-foreground/40 md:text-9xl">404</h1>
          <p className="text-2xl font-bold text-foreground md:text-3xl">{t("notfound.title")}</p>
          <p className="mx-auto max-w-md text-lg text-muted-foreground">{t("notfound.text")}</p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <Button asChild size="lg" className="rounded-lg shadow-glow">
              <Link to="/">{t("nav.backHome")}</Link>
            </Button>
            <Button asChild size="lg" variant="secondary" className="rounded-lg">
              <Link to="/contact">{t("nav.contact")}</Link>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
